// extracted by mini-css-extract-plugin
module.exports = {"container":"_3qjbZ4TeAi6nNG8XPTSq7T","heading":"_2JcMEfo7V7gEsVcpcsd1o8","bookMarks":"rU2IoqIUuxgt-4LAuzLgf"};